import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/contact";
import { useT } from "@/lib/i18n";

const WhatsAppFloat = () => {
  const { t } = useT();
  const msg =
    "Hi Little Ark! I'd like to know more about admissions and book a school tour.";
  return (
    <a
      href={buildWhatsAppLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label={t("wa.float")}
    >
      <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-40" />
      <span className="relative flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white rounded-full pl-4 pr-5 py-3 shadow-2xl shadow-green-600/40 transition-transform group-hover:scale-105">
        <MessageCircle className="h-5 w-5" strokeWidth={2.6} />
        <span className="font-display font-semibold hidden sm:inline">{t("wa.float")}</span>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
